<template>
  <div class="__usage-type-selector" v-if="reportTypes.length > 1">
    <OptionItem
      :value="active"
      :data="item"
      v-for="item in reportTypes"
      :key="item.usageType"
      @click="handleClick"
    />
  </div>
</template>

<script>
import Vue from 'vue';
import { mapState, mapGetters, mapMutations } from 'vuex';
import OptionItem from '@/pages/UsageReport/SideList/UsageTypeSelector/OptionItem';

const messages = {
  messages: {
    en: {
      Account: 'Accounts',
      'Cross tag': 'Cross tag',
      Group: 'Groups',
      'Report Filters': 'Report Filters',
      Subscriptions: 'Subscriptions',
      Customers: 'Customers',
    },
    ja: {
      Account: 'アカウント',
      'Cross tag': 'クロスタグ',
      Group: 'グループ',
      'Report Filters': 'Report Filters',
      Subscriptions: 'サブスクリプション',
      Customers: 'カスタマー',
    },
  },
};

export default Vue.extend({
  name: 'UsageTypeSelector',
  i18n: messages,
  components: { OptionItem },
  props: {
    active: String,
  },
  computed: {
    ...mapState({
      display: state => state.userState.meta,
      vendor: state => state.vendor,
    }),

    ...mapGetters('user', ['getResourceTypes']),

    reportTypes() {
      const items = [
        {
          usageType: 'account',
          label: this.vendor === 'azure' ? this.$t('Customers') : this.$t('Account'),
          icon: 'person',
          disabled: false,
          display:
            this.$display('usage_account') &&
            this.$can('ReadAccount') &&
            this.getResourceTypes.includes('account'),
        },
        {
          usageType: 'azure_subscription',
          label: this.$t('Subscriptions'),
          icon: 'manage_accounts',
          disabled: false,
          display:
            this.vendor === 'azure' && this.$display('usage_account') && this.$can('ReadAccount'),
        },
        {
          usageType: 'cross_tag',
          label: this.$t('Cross tag'),
          icon: 'local_offer',
          disabled: false,
          display: this.$display('usage_crosstag') && this.getResourceTypes.includes('tag'),
        },
        {
          usageType: 'acc_group',
          label: this.$t('Group'),
          icon: 'group',
          disabled: this.getResourceTypes.includes('tag'),
          display:
            this.$display('usage_group') &&
            this.$can('ReadGroups') &&
            !this.getResourceTypes.includes('tag'),
        },
        {
          usageType: 'report_filter',
          label: this.$t('Report Filters'),
          icon: 'filter_alt',
          display: false,
          //display: this.$display('wavepro_report_filters') && this.vendor === 'aws',
        },
      ];

      return items.filter(i => {
        if (i.display) return i;
      });
    },
  },
  methods: {
    ...mapMutations('usageReports', ['updateGroupBy']),

    handleClick(type) {
      switch (type) {
        case 'account': {
          this.$router.push('/usage_reports/account').catch(() => {});
          this.updateGroupBy('account');
          break;
        }
        case 'azure_subscription': {
          this.$router.push('/usage_reports/azure_subscription').catch(() => {});
          this.updateGroupBy('azure_subscription');
          break;
        }
        case 'acc_group': {
          this.$router.push('/usage_reports/group').catch(() => {});
          this.updateGroupBy('acc_group');
          break;
        }
        case 'cross_tag': {
          this.$router.push('/usage_reports/cross_tag').catch(() => {});
          this.updateGroupBy('cross_tag');
          break;
        }
        case 'report_filter': {
          this.$router.push('/usage_reports/report_filter').catch(() => {});
          this.updateGroupBy('report_filter');
          break;
        }
        default:
      }
    },
  },
});
</script>

<style lang="scss" scoped>
.__usage-type-selector {
  display: flex;
  justify-content: space-around;
  width: 100%;
  color: rgba($neutral-color, 0.4);
  border-bottom: 1px solid $border-color;
}
</style>
